import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { ActivityStatus, Item } from '@tekman/onmat/models';
import { Subject } from 'rxjs';
@Component({
  selector: 'dropdown-item-selector',
  templateUrl: './dropdown-item-selector.component.html',
  styleUrls: ['./dropdown-item-selector.component.scss'],
})
export class DropdownItemSelectorComponent implements OnInit, OnChanges {
  @Input() additionalTemplate: TemplateRef<any>;
  @Input() tooltip: string[];
  @Input() items: Item[] = [];
  @Input() isResourceActivity: boolean;
  @Input() isEvaluable: boolean;
  @Input() defaultItem: Item;
  @Input() isLomloeEnv: boolean;
  @Output() repeatActivityEmitter = new EventEmitter<void>();
  @Output() selectedItemEmitter = new EventEmitter<Item>();
  selectedItemSubject = new Subject<Item>();
  selectedItem$ = this.selectedItemSubject.asObservable();
  selectedItem: Item = null;
  selectedItemPosition = 0;
  isOpen = false;
  tooltipField3: string;
  tooltipField4: string;
  currentTemplate: TemplateRef<any>;
  status: typeof ActivityStatus = ActivityStatus;
  mouseOnRepeat = false;
  mouseOnNext = false;
  mouseOnPrevious = false;

  ngOnInit(): void {
    this.selectItem(this.defaultItem);
    this.currentTemplate = this.additionalTemplate;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['additionalTemplate']) {
      this.currentTemplate = changes['additionalTemplate'].currentValue;
    }

    if (changes['tooltip']?.currentValue !== undefined) {
      if (!this.isLomloeEnv) {
        this.tooltipField3 = changes['tooltip'].currentValue[0];
        this.tooltipField4 = changes['tooltip'].currentValue[1];
      }
    }

    if (changes['items']?.currentValue && this.selectedItem) {
      const updatedItem = (changes['items'].currentValue as Item[]).find(item => item.id === this.selectedItem.id);
      if (updatedItem) {
        this.selectedItem = updatedItem;
        this.selectedItemPosition = (changes['items'].currentValue as Item[]).indexOf(updatedItem);
      }
    }

    this.isOpen = false;
  }

  openDropdown(event): void {
    this.isOpen = !this.isOpen;
    event.stopPropagation();
  }

  selectItem(item: Item): void {
    this.selectedItem = item;
    this.selectedItemSubject.next(item);
    this.selectedItemEmitter.emit(this.selectedItem);
    this.selectedItemPosition = this.items.indexOf(item);
    this.isOpen = false;
  }

  tooltipFollowMouse(event: MouseEvent): void {
    if (!this.isLomloeEnv) {
      const tooltips: NodeListOf<HTMLElement> = document.querySelectorAll('.widget__tooltip span');
      const coordX = event.offsetX - 75 + 'px',
        coordY = event.offsetY - 30 + 'px';
      for (let i = 0; i <= tooltips.length - 1; i++) {
        tooltips[i].style.top = coordY;
        tooltips[i].style.left = coordX;
      }
    }
  }

  previousItem(): void {
    if (this.items.length > 1) {
      this.selectedItemPosition = this.items.indexOf(this.selectedItem) - 1;
    }
    if (this.selectedItemPosition >= 0) {
      this.selectedItem = this.items[this.selectedItemPosition];
      this.selectedItemEmitter.emit(this.selectedItem);
    }
  }

  nextItem(): void {
    if (this.items.length > 1) {
      this.selectedItemPosition = this.items.indexOf(this.selectedItem) + 1;
    }
    if (this.selectedItemPosition < this.items.length) {
      this.selectedItem = this.items[this.selectedItemPosition];
      this.selectedItemEmitter.emit(this.selectedItem);
    }
  }

  repeatActivity(): void {
    if (this.selectedItem.field2 !== ActivityStatus.PENDING) {
      this.repeatActivityEmitter.emit();
    }
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event: any) {
    this.isOpen = false;
    event.stopPropagation();
  }
}
